import { taskDownload } from 'app/store/task';
import io from 'socket.io-client';
// Порог автоматического скачивания (мс).
// Если отчёт сформировался быстрее этого значения — скачиваем автоматически,
// иначе показываем уведомление с кнопкой для ручного скачивания.
const AUTO_DOWNLOAD_THRESHOLD = 3000;
let taskSocket = null;
let storeRef = null; // будет хранить ссылку на store
// Подписка на события сокета
function subscribeToSocket(socket) {
    socket.on('connect', () => {
        storeRef.dispatch({ type: 'TASK_SOCKET_STATUS', payload: { status: 'OPENED' } });
    });
    socket.on('disconnect', () => {
        storeRef.dispatch({ type: 'TASK_SOCKET_STATUS', payload: { status: 'CLOSED' } });
    });
    socket.on('task:status', (data) => {
        const { taskId, status, result } = data;
        storeRef.dispatch({
            type: 'TASK_UPDATE_STATUS',
            payload: { taskId, status, result: result || null },
        });
    });
    socket.on('task:completed', (data) => {
        var _a, _b;
        const { taskId, result } = data;
        storeRef.dispatch({
            type: 'TASK_UPDATE_STATUS',
            payload: { taskId, status: 'completed', result },
        });
        const task = (_b = (_a = storeRef.getState().task) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.find((t) => t.id === taskId);
        const elapsed = (task === null || task === void 0 ? void 0 : task.createdAt) ? Date.now() - new Date(task.createdAt).getTime() : Infinity;
        if (elapsed < AUTO_DOWNLOAD_THRESHOLD) {
            // Отчёт сформировался быстро — скачиваем автоматически без уведомления с кнопкой
            if (task) {
                storeRef.dispatch(taskDownload(task));
            }
            storeRef.dispatch({
                type: 'NOTIFICATION_ADD_QUEUE',
                payload: {
                    text: 'Отчёт готов, скачивание началось',
                    color: 'success',
                    timeout: 5000,
                },
            });
        }
        else {
            // Отчёт формировался долго — показываем уведомление с возможностью скачать
            storeRef.dispatch({
                type: 'NOTIFICATION_ADD_QUEUE',
                payload: {
                    text: 'Отчёт готов к скачиванию',
                    color: 'success',
                    timeout: 0,
                    action: () => {
                        var _a, _b;
                        const task = (_b = (_a = storeRef.getState().task) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.find((t) => t.id === taskId);
                        if (task) {
                            storeRef.dispatch(taskDownload(task));
                        }
                    },
                },
            });
        }
    });
    socket.on('task:failed', (data) => {
        const { taskId, error } = data;
        storeRef.dispatch({
            type: 'TASK_UPDATE_STATUS',
            payload: { taskId, status: 'failed', result: { error } },
        });
        storeRef.dispatch({
            type: 'NOTIFICATION_ADD_QUEUE',
            payload: {
                text: `Ошибка создания отчёта: ${error}`,
                color: 'error',
                timeout: 8000,
            },
        });
    });
    // Можно добавить другие события при необходимости
}
// Middleware creator
export const taskSocketMiddleware = () => {
    return (store) => {
        storeRef = store; // сохраняем ссылку для использования в колбэках
        return (next) => (action) => {
            switch (action.type) {
                case 'TASK_SOCKET_CONNECT': {
                    if (taskSocket && taskSocket.connected) {
                        return;
                    }
                    // Создаём подключение к namespace /tasks
                    taskSocket = io(`${window.location.origin}/tasks`, {
                        withCredentials: true,
                        transports: ['websocket'],
                    });
                    subscribeToSocket(taskSocket);
                    break;
                }
                case 'TASK_SOCKET_DISCONNECT':
                case 'SESSION_DELETE': {
                    if (taskSocket) {
                        taskSocket.disconnect();
                        taskSocket = null;
                    }
                    break;
                }
                default:
                    break;
            }
            return next(action);
        };
    };
};
export default taskSocketMiddleware;
